import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import map from "lodash/map";
import get from "lodash/get";

import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Global, css } from "@emotion/react";

import { basePhotographList, photographList } from "../../v2_actions/customer_photograph";
import { albumListForEventTab } from "../../v2_actions/customer_album";

import AlbumFacialRecognition from "../../v2_components/AlbumFacialRecognition";
import AlbumBibNumber from "../../v2_components/AlbumBibNumber";
import BibNumberIconImg from "../../assets/icon/bib number icon.jpg";

import { styles } from "./styles";
import { makeLogger } from "../../utils/o11y/logger";

const logger = makeLogger({
  enabled: true,
  label: "AlbumPageFilter",
  color: "pink",
});

const useStyles = makeStyles(styles);

const global_styles = css`
  div.MuiAccordion-root {
  font-size: 12px;
  background: #f4f4f4;
  }
  div.MuiAccordionSummary-expandIconWrapper.Mui-expanded {
  transform: inherit;
  }
  div.MuiAccordion-root {
  box-shadow: none;
  }
  div.MuiAccordionSummary-root {
  padding-left: 0px;
  background: #f4f4f4;
  }
  div.MuiAccordionSummary-content {
  left: 35px;
  position: absolute;
  }
  div.MuiAccordionSummary-expandIconWrapper {
  left: 0px;
  position: absolute;
  }
  div.MuiAccordionSummary-expandIconWrapper svg {
  width: 25px;
  height: 24px;
  }
`;

export default function AlbumPageFilter({ albumNameForAPI }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const album = useSelector(() => albumListForEventTab.getAlbumForAlbumName(albumNameForAPI));
  const hasBibNumberIndexedGallery = get(album, "has_bib_number_indexed_gallery", false);
  const [showClearFiltersButton, setShowClearFiltersButton] = useState(false);
  const [isFacialRecognitionFilterActive, setIsFacialRecognitionFilterActive] = useState(false);
  const [clearFiltersWasClicked, setClearFiltersWasClicked] = useState(false);
  const [expandActiveMobileTabFilter, setExpandActiveMobileTabFilter] = useState(true);
  const [
    mayPerformFacialRecognitionIndexingOfGalleryPhotographs,
    setMayPerformFacialRecognitionIndexingOfGalleryPhotographs,
  ] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState("facialRecognition");

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };  

  const renderFacialRecognitionFilter = () => {
    return (
      <Stack direction={{ xs: "column", sm: "row" }}>
        <AlbumFacialRecognition
          albumNameForAPI={albumNameForAPI}
          clearFiltersWasClicked={clearFiltersWasClicked}
          setClearFiltersWasClicked={setClearFiltersWasClicked}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
          setIsFacialRecognitionFilterActive={setIsFacialRecognitionFilterActive}
        />
      </Stack>
    );
  };

  const renderBibNumberFilter = () => {
    return (
      <Stack direction={{ xs: "column", sm: "row" }}>
        <AlbumBibNumber
          albumNameForAPI={albumNameForAPI}
          clearFiltersWasClicked={clearFiltersWasClicked}
          setClearFiltersWasClicked={setClearFiltersWasClicked}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
        />
      </Stack>
    );
  };

  const clearFilters = () => {
    setIsFacialRecognitionFilterActive(false);
    setClearFiltersWasClicked(true);

    setExpandActiveMobileTabFilter(false);
    dispatch(photographList.clearListFilter());
    dispatch(basePhotographList.clearListFilter());
  };

  const sideMenuFilters = [
    {
      icon: <PersonSearchIcon />,
      heading: "Facial Recognition",
      body: renderFacialRecognitionFilter(),
      panel: "facialRecognition",
    },
    ...(hasBibNumberIndexedGallery ? [{
      icon: <img src={BibNumberIconImg} alt="Bib number" style={{ width: '24px', height: '24px' }} />,
      heading: "Bib number",
      body: renderBibNumberFilter(),
      panel: "bibNumber",
    }] : []),
  ];

  const renderClearFilters = () => {
    return (
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <Button
          variant="contained"
          onClick={clearFilters}
          endIcon={<CloseIcon />}
          className={classes.clearFiltersButton}
        >
          <p className={classes.clearFiltersButtonText}>Clear Filters</p>
        </Button>
      </Stack>
    );
  };

  return (
    <>
      <Global styles={global_styles} />
      <aside className={classes.sidebarForGalleryPhotographDesktop}>
        {map(sideMenuFilters, (sideMenuFilter, index) => (
          <Accordion
            key={sideMenuFilter.panel}
            className={classes.accordion}
            IconButtonProps={{ edge: "start" }}
            expanded={expandedPanel === sideMenuFilter.panel}
            onChange={handleAccordionChange(sideMenuFilter.panel)}
          >
            <AccordionSummary
              id={index}
              expandIcon={sideMenuFilter.icon}
              aria-controls="panel1a-content"
              className={classes.galleryPhotographsAccordionSummary}
            >
              <p className={classes.accordianHeading}>
                {sideMenuFilter.heading}
              </p>
            </AccordionSummary>
            <AccordionDetails>{sideMenuFilter.body}</AccordionDetails>
          </Accordion>
        ))}
      </aside>
    </>
  );
}
